<template>
  <div class="exam">
    exam
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      
    };
  },
  created() {
    this.fetchExamDataList()
  },
  methods: {
    ...mapActions(['fetchExamDataList'])
  }
};
</script>

<style scoped>
.exam {
  
}
</style>
